/**
 * 商品详情页展示逻辑（canvas-new 小程序预览与后台预览共用）
 * 修改此文件后请同步 canvas-new/shared/product-detail/productDetailLogic.js
 */

export function normalizeImages(value) {
  if (!value) return []
  if (Array.isArray(value)) {
    return value.filter((item) => item && String(item).trim())
  }
  if (typeof value === 'string') {
    const str = value.trim()
    if (!str) return []
    if (str.startsWith('[')) {
      try {
        const parsed = JSON.parse(str)
        if (Array.isArray(parsed)) {
          return parsed.filter((item) => item && String(item).trim())
        }
      } catch {
        // ignore
      }
    }
    return str.split(',').map((item) => item.trim()).filter(Boolean)
  }
  return []
}

export function craftTagsArray(craftTags) {
  if (!craftTags) return []
  return String(craftTags).split(',').filter((tag) => tag && tag.trim())
}

export function getSelectedColor(details, colorId, colorIndex) {
  const colors = details?.info?.colors
  if (colorId && colorIndex >= 0 && colors && colors[colorIndex]) {
    return colors[colorIndex]
  }
  return null
}

export function getSwiperImages(details, selectedColor) {
  if (selectedColor?.carousel_images) {
    const colorCarousel = normalizeImages(selectedColor.carousel_images)
    if (colorCarousel.length > 0) return colorCarousel
  }
  const displayImages = normalizeImages(details?.info?.display_images)
  if (displayImages.length > 0) return displayImages
  if (selectedColor?.main_image) return [selectedColor.main_image]
  if (details?.info?.image) return [details.info.image]
  return []
}

export function getColorDetailImages(selectedColor) {
  if (!selectedColor?.detail_images) return []
  if (Array.isArray(selectedColor.detail_images) && selectedColor.detail_images.length > 0) {
    return selectedColor.detail_images
  }
  if (typeof selectedColor.detail_images === 'string') {
    return selectedColor.detail_images.split(',').map((item) => item.trim()).filter(Boolean)
  }
  return []
}

export function getMainDetailImages(info) {
  const imgs = info?.images
  if (!imgs) return []
  if (Array.isArray(imgs)) return imgs
  try {
    return JSON.parse(imgs)
  } catch {
    return []
  }
}

export function computeTotalPrice(details, selection = {}) {
  const info = details?.info || {}
  const basePrice = parseFloat(info.price) || 0
  let specPrice = 0
  const {
    colorId,
    colorIndex = -1,
    spec1Id,
    spec1Index = -1,
    spec2Id,
    spec2Index = -1,
  } = selection

  if (colorId && colorIndex >= 0 && info.colors?.[colorIndex]) {
    specPrice += parseFloat(info.colors[colorIndex].price) || 0
  }
  if (spec1Id && spec1Index >= 0 && info.spec1?.[spec1Index]) {
    specPrice += parseFloat(info.spec1[spec1Index].price) || 0
  }
  if (spec2Id && spec2Index >= 0 && info.spec2?.[spec2Index]) {
    specPrice += parseFloat(info.spec2[spec2Index].price) || 0
  }
  return (basePrice + specPrice).toFixed(2)
}

export function getSpecStock(stockItems, colorId, spec1Id, spec2Id) {
  const key = `${colorId || 0}_${spec1Id || 0}_${spec2Id || 0}`
  const val = stockItems?.[key]
  return val != null ? Number(val) || 0 : 0
}

function isColorAvailableInit(stockItems, colorId, spec1 = [], spec2 = []) {
  if ((!spec1 || spec1.length === 0) && (!spec2 || spec2.length === 0)) {
    return getSpecStock(stockItems, colorId, 0, 0) > 0
  }
  if (spec1?.length > 0 && (!spec2 || spec2.length === 0)) {
    return spec1.some((item) => getSpecStock(stockItems, colorId, item.id, 0) > 0)
  }
  if ((!spec1 || spec1.length === 0) && spec2?.length > 0) {
    return spec2.some((item) => getSpecStock(stockItems, colorId, 0, item.id) > 0)
  }
  for (const s1 of spec1) {
    for (const s2 of spec2) {
      if (getSpecStock(stockItems, colorId, s1.id, s2.id) > 0) return true
    }
  }
  return false
}

export function initProductDetailSelection(details, presetColorId = null) {
  const info = details?.info || {}
  const colors = info.colors || []
  const spec1 = info.spec1 || []
  const spec2 = info.spec2 || []
  const stockItems = details?.stock_items || {}
  const state = {
    colorId: '',
    colorIndex: -1,
    spec1Id: '',
    spec1Index: -1,
    spec2Id: '',
    spec2Index: -1,
  }

  if (colors.length > 0) {
    let presetIndex = -1
    if (presetColorId) {
      presetIndex = colors.findIndex((c) => String(c.id) === String(presetColorId))
    }
    if (presetIndex >= 0) {
      state.colorId = colors[presetIndex].id
      state.colorIndex = presetIndex
    } else {
      const firstAvailable = colors.findIndex((c) => isColorAvailableInit(stockItems, c.id, spec1, spec2))
      const index = firstAvailable >= 0 ? firstAvailable : 0
      state.colorId = colors[index].id
      state.colorIndex = index
    }
  }

  if (spec1.length > 0) {
    const firstAvailable = spec1.findIndex((item) => {
      if (spec2.length === 0) {
        return getSpecStock(stockItems, state.colorId || 0, item.id, 0) > 0
      }
      return spec2.some((s2) => getSpecStock(stockItems, state.colorId || 0, item.id, s2.id) > 0)
    })
    const index = firstAvailable >= 0 ? firstAvailable : 0
    state.spec1Id = spec1[index].id
    state.spec1Index = index
  }

  if (spec2.length > 0) {
    const firstAvailable = spec2.findIndex((item) =>
      getSpecStock(stockItems, state.colorId || 0, state.spec1Id || 0, item.id) > 0
    )
    const index = firstAvailable >= 0 ? firstAvailable : 0
    state.spec2Id = spec2[index].id
    state.spec2Index = index
  }

  return state
}

export function showCraftTagsSection(info) {
  if (!info) return false
  return !!(
    info.craft_tags
    || info.is_custom == 1
    || info.is_alone == 1
    || info.is_alone == 2
    || info.is_alone == 3
  )
}
